define('views/modals/messenger/message-list',['require','views/base/collection','views/modals/messenger/message-item','text!templates/modals/messenger/message-list.ejs'],function(require) {
    'use strict';

    var CollectionView = require('views/base/collection'),
        MessageItemView = require('views/modals/messenger/message-item'),
        template = require('text!templates/modals/messenger/message-list.ejs');

    var MessageListView = CollectionView.extend({
        template: template,
        itemView: MessageItemView,
        className: 'messenger-message-list',
        loadingSelector: '.loading',
        fallbackSelector: '.empty',
        listSelector: 'tbody',
        region: 'modal-content',
        animationDuration: 0,
        listen: {
            'add collection': 'scrollDown',
            'reset collection': 'scrollDown',
            'resize collection': 'scrollDown'
        },
        scrollDown: function() {
            this.$list.scrollTop(this.$list[0].scrollHeight);
        }
    });

    return MessageListView;
});

